import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapPin, Navigation, School, ShoppingBag } from 'lucide-react';

const LocationSection = () => {
  const { t } = useTranslation();
  
  const locations = [
    {
      icon: <Navigation className="w-6 h-6" />,
      title: t('location.features.beach.title'),
      distance: t('location.features.beach.description')
    },
    {
      icon: <ShoppingBag className="w-6 h-6" />,
      title: t('location.features.shops.title'),
      distance: t('location.features.shops.description')
    },
    {
      icon: <School className="w-6 h-6" />,
      title: t('location.features.schools.title'),
      distance: t('location.features.schools.description')
    },
    {
      icon: <MapPin className="w-6 h-6" />,
      title: t('location.features.park.title'),
      distance: t('location.features.park.description')
    }
  ];

  return (
    <section id="location" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-[#003366] mb-4">
            {t('location.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t('location.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-12">
          {/* Image */}
          <div className="order-2 md:order-1">
            <img
              src="https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/e2dy74jj_Slide_Marimurtra_1200x700-11.jpg"
              alt={t('location.title')}
              className="rounded-lg shadow-2xl w-full h-[400px] object-cover"
            />
          </div>

          {/* Location Details */}
          <div className="order-1 md:order-2 grid grid-cols-2 gap-6">
            {locations.map((location, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-blue-50 to-yellow-50 p-6 rounded-lg border border-blue-100 hover:shadow-lg transition-shadow"
              >
                <div className="inline-flex items-center justify-center w-12 h-12 bg-[#0052CC] text-white rounded-full mb-3">
                  {location.icon}
                </div>
                <h3 className="font-bold text-gray-900 mb-1">{location.title}</h3>
                <p className="text-sm text-gray-600">{location.distance}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Map */}
        <div className="mt-12">
          <div className="rounded-lg overflow-hidden shadow-2xl h-[500px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11850!2d2.805!3d41.6754!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f12!3m3!1m2!1s0x12bae2befb0d0001%3A0x1!2sAv.%20de%20la%20Pau%2C%2041%2C%2017300%20Blanes%2C%20Girona%2C%20Spain!5e0!3m2!1sen!2s!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Residencial Los Jardines Location"
            ></iframe>
          </div>
        </div>

        {/* Additional Info */}
        <div className="bg-gradient-to-r from-blue-50 to-yellow-50 p-8 rounded-lg mt-8">
          <div className="flex items-center justify-center gap-4">
            <MapPin className="w-8 h-8 text-[#0052CC]" />
            <p className="text-lg text-gray-700">
              {t('location.highway')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;